import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'

import { get } from 'lodash'

import { locales } from '@/utils'

import render from './render'

export default {
  name: 'MobilePanel',

  data() {
    return {
      isJivositeOpen: false
    }
  },

  computed: {
    items() {
      const result = [
        {
          name: 'create',
          icon: 'send',
          to: { name: 'create' }
        },
        {
          name: 'templates',
          icon: 'information',
          to: {
            name: 'create',
            query: { currentTab: 'templates' }
          }
        }
      ]
      const jivosite = get(this.globalSettings, 'frontend.jivosite')
      const contacts = get(this.globalSettings, 'contacts')

      const routeToSupport = {
        name: 'support',
        icon: 'question',
        to: { name: 'support' }
      }

      switch (this.locale) {
        case locales.en: {
          if (contacts) {
            result.push(routeToSupport)
          }
          break
        }

        case locales.ru:
        default: {
          if (jivosite) {
            result.push({
              name: 'jivosite',
              icon: 'question'
            })
          } else if (contacts) {
            result.push(routeToSupport)
          }
          break
        }
      }

      result.push({
        name: 'payment',
        icon: 'wallet-add'
      })

      return result
    },

    ...mapGetters({
      tab: 'currentTab/tab',
      showPaymentDialog: 'payments/showPaymentDialog'
    })
  },

  watch: {
    $route: {
      handler() {
        this.init()
      },
      deep: true
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    init() {
      const { name, query = {} } = this.$route
      const itemName = query.currentTab || name
      const matchingItem = this.items.find(item => {
        return item.name === itemName
      })

      if (matchingItem) {
        this.setCurrentTab(matchingItem)
      } else {
        this.setCurrentTab({
          name: undefined,
          to: {}
        })
      }
    },

    itemProcessor(item) {
      switch (item.name) {
        case 'create':
        case 'templates':
        case 'support': {
          this.closeJivosite()
          this.setTabItemAndPush(item)
          this.setShowPaymentDialog(false)
          break
        }

        case 'payment': {
          this.closeJivosite()
          this.setShowPaymentDialog(true)
          break
        }

        case 'jivosite': {
          this.setShowPaymentDialog(false)
          if (window.jivo_api) {
            this.isJivositeOpen = true
            const container = document.querySelector('jdiv')
            container?.classList.remove('jivo-override')
            window.jivo_api.open()
          }
          break
        }
      }
    },

    setTabItemAndPush(tab) {
      if (this.items.some(item => {
        return item.name === tab.name
      })) {
        this.setCurrentTab(tab)

        if (tab.to) {
          Vue.router.push(tab.to)
        }
      }
    },

    closeJivosite() {
      if (window.jivo_api && this.isJivositeOpen) {
        this.isJivositeOpen = false
        window.jivo_api.close()
      }
    },

    ...mapActions({
      setCurrentTab: 'currentTab/setCurrentTab',
      setShowPaymentDialog: 'payments/setShowPaymentDialog'
    })
  },

  render
}
